import { type Themes } from '@smart/web-foundations';
import React from 'react';

interface ThemeContextValue {
  theme: Themes;
  setTheme: (theme: Themes) => void;
}

const ThemeContext = React.createContext<ThemeContextValue | undefined>(
  undefined,
);

interface ThemeProviderProps {
  theme?: Themes;
  children: React.ReactNode;
}

export const ThemeContextProvider = ({
  theme,
  children,
}: ThemeProviderProps) => {
  const [defaultTheme, setTheme] = React.useState<Themes>(theme ?? 'light');

  return (
    <ThemeContext.Provider value={{ theme: theme ?? defaultTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

ThemeContextProvider.displayName = 'ThemeContextProvider';

export const useTheme = (): {
  theme: Themes;
  setTheme: (theme: Themes) => void;
} => {
  const context = React.useContext(ThemeContext);
  if (!context) {
    return {
      theme: 'light',
      setTheme: () => undefined,
    };
  }
  return context;
};
